import { HttpErrorResponse } from '@angular/common/http';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as fromActions from '../actions/invitations.actions';
import type { GetInvitationDto } from '../dtos/getInvitationDto.interface';
export interface FeatureState {
    invitation: GetInvitationDto | undefined;
    error: HttpErrorResponse | undefined;
}
export interface AppState {
    aumicoInvitationFeature: FeatureState;
}

export const initialState: FeatureState = {
    invitation: undefined,
    error: undefined,
};

const invitationReducer = createReducer(
    initialState,
    on(fromActions.invitation.get, (state: FeatureState) => ({ ...state, error: undefined })),
    on(fromActions.invitation.getSuccess, (state: FeatureState, action) => ({
        ...state,
        invitation: action.payload,
        error: undefined,
    })),
    on(fromActions.invitation.getFailure, (state: FeatureState, action) => ({
        ...state,
        invitation: undefined,
        error: action.payload,
    })),
);

export const invitationFeature = createFeature({
    name: 'aumicoInvitationFeature',
    reducer: invitationReducer,
});

export const { name, reducer, selectError, selectInvitation } = invitationFeature;
